module.exports = __webpack_public_path__ + "clubhouse.3851be.svg";